import { ArchiveResource } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { ArchiveDataStore } from "@skinsoft/entity";
import { ArchiveOfflineDataFetcher, CACHE_KEYS } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.location ?? config.syncDownPageSize.default

// @ts-ignore
export class ArchiveSyncDownHandler extends EntitySyncDownHandler<ArchiveResource, ArchiveResource, ArchiveResource> {
    private static instance: ArchiveSyncDownHandler = null as any

    public static getInstance() {
        if (!ArchiveSyncDownHandler.instance) {
            ArchiveSyncDownHandler.instance = new ArchiveSyncDownHandler()
        }

        return ArchiveSyncDownHandler.instance
    }

    public static install(Vue) {
        ArchiveSyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.archive],
            ArchiveDataStore.getInstance(),
            new ArchiveOfflineDataFetcher(),
            CACHE_KEYS.Archive,
            SEARCH_PAGE_SIZE
        )
    }
}